module.exports = __webpack_public_path__ + "static/img/共享运营平台3.d1dcad72.png";